import {
    LIST_PAYMENT_METHODS,
    ADD_PAYMENT_METHOD,
    CONFIRM_PAYMENT,
    DELETE_PAYMENT_METHOD,
    MARK_AS_DEFAULT,
    UPDATE_PAYMENT_DETAIL
} from './action.type'
import $axios from '../../helpers/axios-instance';

export default {

    [LIST_PAYMENT_METHODS](context) {

        return new Promise((resolve, reject) => {
            $axios.get('/purchase/listAllPaymentMethods').then(response => {

                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    [ADD_PAYMENT_METHOD](context, body) {

        return new Promise((resolve, reject) => {
            $axios.post('/purchase/addNewCard', {
                ...body
            }).then(response => {

                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    [CONFIRM_PAYMENT](context, body) {

        return new Promise((resolve, reject) => {
            $axios.post('/purchase/makePayment', {
                ...body
            }).then(response => {

                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    [DELETE_PAYMENT_METHOD](context, body) {

        return new Promise((resolve, reject) => {
            $axios.post('/purchase/deleteCard', {
                ...body
            }).then(response => {

                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    [MARK_AS_DEFAULT](context, body) {

        return new Promise((resolve, reject) => {
            $axios.post('/purchase/makeDefaultPaymentMethod', {
                ...body
            }).then(response => {

                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    [UPDATE_PAYMENT_DETAIL](context, body) {

        return new Promise((resolve, reject) => {
            $axios.post('/purchase/updatePayment', {
                ...body
            }).then(response => {

                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}